/* loaded by smart-asset */
export default require("./errorIcon~HvdaekLZ.svg")